import React from 'react'
import '../../../css/page/CouponSPA.css'
import cn from 'classnames'
import {getJsonFromUrl} from "../../../utils";
import { prodConfig } from '../../../config'

class ActivityBagForNew extends React.Component{
    constructor(props) {
        super(props)
        this.bagid = getJsonFromUrl().bagid
    }
    render(){
        const { remainder_number,price } = this.props.coupon
        const NewBagidStyle = {
            background: `url(${this.bagid === '8' && 'https://static-1253442168.image.myqcloud.com/picture/10490565_e555cfd2cdb58259b0491699ed31c6e7.jpg'}`,
            paddingTop: this.bagid === '8' && '1vh',
            backgroundSize: this.bagid === '8' && 'cover'
        }
        let couponArr = [];
        switch(remainder_number){
                case 0:
                    couponArr = [{index:1,isUse:'true'},{index:2,isUse:'true'},{index:3,isUse:'true'}]
                    break;
                case 1:
                    couponArr = [{index:1,isUse:'true'},{index:2,isUse:'true'},{index:3,isUse:'false'}]
                    break;
                case 2:
                    couponArr = [{index:1,isUse:'true'},{index:2,isUse:'false'},{index:3,isUse:'false'}]
                    break;
                case 3:
                    couponArr = [{index:1,isUse:'false'},{index:2,isUse:'false'},{index:3,isUse:'false'}]
                    break;
        }

        return (
            <div className={cn("no-prize-header", 'is-new-people')}>
                <div className="coupon_newBanner" style={NewBagidStyle}>

                    {remainder_number!==0 ?
                        <div className="coupon_big_title">
                            你还有{ price * remainder_number }元红包未使用
                        </div>
                        :
                        <div className="coupon_big_title coupon_big_title_ifNoCoupon">
                            哇塞，你的红包已用完<br/>去其他活动页逛逛吧！
                        </div>
                    }

                    {remainder_number === 0 &&
                    <div className="BoutiqueBtn">
                        <span onClick={()=>window.location.assign(`${prodConfig.MAIN_URL}/activity/seckill?inviter_id=61329186`)}>精品低价专区</span>
                    </div>
                    }

                    <div className="coupon_show_area" style={remainder_number==0  ? { paddingTop: 45 } : null }>
                        {remainder_number !== 0  &&
                        <div className="coupon_show_area_list">
                            {couponArr.map((v) => {
                                return (
                                    v.isUse == 'true' ?
                                        <div key={v.index} className="coupon_show_area_info">
                                         <span className="ifUse"><i>¥</i><p>{+price}</p>
                                         </span>
                                            <img
                                                src="https://static-1253442168.image.myqcloud.com/picture/8173011_0ac8a39f884c38869395751206f3373b.jpg"
                                                alt=""/>
                                        </div>
                                        :
                                        <div key={v.index} className="coupon_show_area_info">
                                            <span><i>¥</i><p>{+price}</p></span>
                                            <img
                                                src="https://static-1253442168.image.myqcloud.com/picture/8173011_324bbe1517947e0c420fd4d69425021e.jpg"
                                                alt=""/>
                                        </div>
                                )
                            })}
                        </div>
                        }
                        <div className="roundbg"><img src="https://static-1253442168.image.myqcloud.com/picture/8173011_02788ea0317b8a603296a6f294caa2d3.jpg" alt=""/></div>
                    </div>

                </div>
            </div>
        )

    }
}

export default ActivityBagForNew


// WEBPACK FOOTER //
// ./src/components/activity/couponSPA/ActivityBagForNew.js